module.exports = __webpack_public_path__ + "b85404cdf4afbfc6f4678886f518d16d.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-ankur.png
// module id = 650
// module chunks = 0